import { render, staticRenderFns } from "./Shopmonkey.vue?vue&type=template&id=ea7bc4c8"
import script from "./Shopmonkey.vue?vue&type=script&lang=js"
export * from "./Shopmonkey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports